import React from "react";
import AreaGraph from "../Chart/AreaGraph";
import { useEffect } from "react";
import { useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import {
  getAllModuleInfo,
  getStorageInfo,
} from "../../../redux/actions/billing";

function PlanUsage({ openTab }) {
  const [data, setData] = useState("");
  const { StorageList, AllModuleInfo } = useSelector((state) => state.billing);
  const dispatch = useDispatch();
  useEffect(() => {
    dispatch(getStorageInfo());
    dispatch(getAllModuleInfo());
  }, []);
  useEffect(() => {
    if (StorageList) {
      const bytes = StorageList.totalSize;
      function readableBytes(bytes) {
        var i = Math.floor(Math.log(bytes) / Math.log(1024)),
          sizes = ["B", "KB", "MB", "GB", "TB", "PB", "EB", "ZB", "YB"];
        return (bytes / Math.pow(1024, 2)).toFixed(2) * 1 + " " + sizes[2];
      }
      const res = readableBytes(bytes);
      setData(res);
    }
  }, [StorageList]);
  return (
    <div className={`${openTab === 1 ? "block" : "hidden"} py-4 space-y-4`}>
      <div className="flex justify-between items-center">
        <h4 className="text-base font-bold">
          {AllModuleInfo?.currentPlan ? AllModuleInfo.currentPlan : ""} Plan
        </h4>
        {/* <button className="btn-sm rounded-full bg-[--bg-color-500] text-white text-xs leading-3 tracking-tight w-20">
          Upgrade
        </button> */}
      </div>
      <div className="shadow border border-[#D9D9D9] rounded-[10px] grid grid-cols-1 lg:grid-cols-3 xl:grid-cols-3 gap-1 h-auto lg:h-[107px]">
        <div className="p-5 space-y-2 border-b lg:border-b-0 lg:border-r">
          <div className="flex justify-between items-center">
            <h3 className="text-[13px] font-inter font-medium text-[#313439]">
              Users
            </h3>
            <p
              className={`font-inter text-[10px] ${
                AllModuleInfo?.Users && AllModuleInfo?.totalUsers
                  ? AllModuleInfo.Users - AllModuleInfo.totalUsers <= 0
                    ? `text-[#ED2F2F]`
                    : `text-[--bg-color-500]`
                  : ""
              } leading-[100%] font-medium`}
            >
              {AllModuleInfo?.Users && AllModuleInfo?.totalUsers
                ? AllModuleInfo.Users - AllModuleInfo.totalUsers
                : ""}{" "}
              Users left
            </p>
          </div>
          <div>
            <span className="text-[--bg-color-500] text-2xl leading-6 font-semibold">
              {AllModuleInfo?.totalUsers ? AllModuleInfo.totalUsers : ""}
            </span>
            <span className="text-[13px] leading-[13px] font-medium text-[#858585]">
              &nbsp; from {AllModuleInfo?.Users ? AllModuleInfo.Users : ""}{" "}
              Users
            </span>
          </div>
        </div>

        <div className="p-5 space-y-2 border-b lg:border-b-0 lg:border-r">
          <div className="flex justify-between items-center">
            <h3 className="text-[13px] font-inter font-medium text-[#313439]">
              Workflows
            </h3>
            <p
              className={`font-inter text-[10px] ${
                AllModuleInfo?.workflows && AllModuleInfo?.totalWorkflow
                  ? AllModuleInfo.workflows - AllModuleInfo.totalWorkflow <= 0
                    ? `text-[#ED2F2F]`
                    : `text-[--bg-color-500]`
                  : ""
              } leading-[100%] font-medium`}
            >
              {AllModuleInfo?.workflows && AllModuleInfo?.totalWorkflow
                ? AllModuleInfo.workflows - AllModuleInfo.totalWorkflow
                : ""}{" "}
              Workflows left
            </p>
          </div>
          <div>
            <span className="text-[--bg-color-500] text-2xl leading-6 font-semibold">
              {AllModuleInfo?.totalWorkflow ? AllModuleInfo.totalWorkflow : ""}
            </span>
            <span className="text-[13px] leading-[13px] font-medium text-[#858585]">
              &nbsp; from{" "}
              {AllModuleInfo?.workflows ? AllModuleInfo.workflows : ""}{" "}
              Workflows
            </span>
          </div>
        </div>

        <div className="p-5 space-y-2">
          <div className="flex justify-between items-center">
            <h3 className="text-[13px] font-inter font-medium text-[#313439]">
              To Dos
            </h3>
            <p
              className={`font-inter text-[10px] ${
                AllModuleInfo?.todo && AllModuleInfo?.totalToDo
                  ? AllModuleInfo.todo - AllModuleInfo.totalToDo <= 0
                    ? `text-[#ED2F2F]`
                    : `text-[--bg-color-500]`
                  : ""
              } leading-[100%] font-medium`}
            >
              {AllModuleInfo?.todo && AllModuleInfo?.totalToDo
                ? AllModuleInfo.todo - AllModuleInfo.totalToDo
                : ""}{" "}
              To Dos left
            </p>
          </div>
          <div>
            <span className="text-[--bg-color-500] text-2xl leading-6 font-semibold">
              {AllModuleInfo?.totalToDo ? AllModuleInfo.totalToDo : ""}
            </span>
            <span className="text-[13px] leading-[13px] font-medium text-[#858585]">
              &nbsp; from {AllModuleInfo?.todo ? AllModuleInfo.todo : ""} To Dos
            </span>
          </div>
        </div>
      </div>

      <div className="shadow border border-[#D9D9D9] rounded-[10px] grid grid-cols-1 lg:grid-cols-3 xl:grid-cols-3 gap-1 h-auto lg:h-[107px]">
        <div className="p-5 space-y-2 border-b lg:border-b-0 lg:border-r">
          <div className="flex justify-between items-center">
            <h3 className="text-[13px] font-inter font-medium text-[#313439]">
              Bookings{" "}
              {AllModuleInfo?.currentMonth ? AllModuleInfo.currentMonth : ""}
            </h3>
            <p
              className={`font-inter text-[10px] ${
                AllModuleInfo?.Bookings &&
                AllModuleInfo?.totalBookingCreatedThisMonth
                  ? AllModuleInfo.Bookings -
                      AllModuleInfo.totalBookingCreatedThisMonth <=
                    0
                    ? `text-[#ED2F2F]`
                    : `text-[--bg-color-500]`
                  : ""
              } leading-[100%] font-medium`}
            >
              {AllModuleInfo?.Bookings &&
              AllModuleInfo?.totalBookingCreatedThisMonth
                ? AllModuleInfo.Bookings -
                  AllModuleInfo.totalBookingCreatedThisMonth
                : ""}{" "}
              Bookings left
            </p>
          </div>
          <div>
            <span className="text-[--bg-color-500] text-2xl leading-6 font-semibold">
              {AllModuleInfo?.totalBookingCreatedThisMonth
                ? AllModuleInfo.totalBookingCreatedThisMonth
                : ""}
            </span>
            <span className="text-[13px] leading-[13px] font-medium text-[#858585]">
              &nbsp; from{" "}
              {AllModuleInfo?.Bookings ? AllModuleInfo.Bookings : ""} Bookings
            </span>
          </div>
        </div>

        <div className="p-5 space-y-2 border-b lg:border-b-0 lg:border-r">
          <div className="flex justify-between items-center">
            <h3 className="text-[13px] font-inter font-medium text-[#313439]">
              Booking Forms
            </h3>
            <p
              className={`font-inter text-[10px] ${
                AllModuleInfo?.BookingTemplate &&
                AllModuleInfo?.totalBookingTemplate
                  ? AllModuleInfo.BookingTemplate -
                      AllModuleInfo.totalBookingTemplate <=
                    0
                    ? `text-[#ED2F2F]`
                    : `text-[--bg-color-500]`
                  : ""
              } leading-[100%] font-medium`}
            >
              {AllModuleInfo?.BookingTemplate &&
              AllModuleInfo?.totalBookingTemplate
                ? AllModuleInfo.BookingTemplate -
                  AllModuleInfo.totalBookingTemplate
                : ""}{" "}
              Forms left
            </p>
          </div>
          <div>
            <span className="text-[--bg-color-500] text-2xl leading-6 font-semibold">
              {AllModuleInfo?.totalBookingTemplate
                ? AllModuleInfo.totalBookingTemplate
                : ""}
            </span>
            <span className="text-[13px] leading-[13px] font-medium text-[#858585]">
              &nbsp; from{" "}
              {AllModuleInfo?.BookingTemplate
                ? AllModuleInfo.BookingTemplate
                : ""}{" "}
              Booking Forms
            </span>
          </div>
        </div>

        <div className="p-5 space-y-4">
          <div className="flex justify-between items-center">
            <h3 className="text-[13px] font-inter font-medium text-[#313439]">
              Cloud Storage
            </h3>
            <p className="font-inter text-[10px] text-[--bg-color-500] leading-[100%] font-medium">
              {StorageList?.totalSize && AllModuleInfo?.storage
                ? 100 -
                  ((StorageList.totalSize / (1000 * 1000 * 1000)).toFixed(2) /
                    AllModuleInfo.storage) *
                    100
                : 0}
              % left
            </p>
          </div>
          <div className="space-y-1">
            <div class="flex-start flex h-4 w-full overflow-hidden bg-[#F3F3F3] font-sans text-xs font-medium rounded-full">
              <div
                class="flex h-full items-baseline justify-center overflow-hidden break-all bg-[--bg-color-500] text-white"
                style={{
                  width: `${
                    StorageList?.totalSize && AllModuleInfo?.storage
                      ? ((StorageList.totalSize / (1000 * 1000 * 1000)).toFixed(
                          2
                        ) /
                          AllModuleInfo.storage) *
                        100
                      : 0
                  }%`,
                }}
              ></div>
            </div>
            <div className="flex justify-end ">
              <p className="text-[#858585] text-[10px] font-inter leading-[10px] font-medium">
                {data} of {AllModuleInfo?.storage ? AllModuleInfo.storage : ""}{" "}
                GB used
              </p>
            </div>
          </div>
        </div>
      </div>

      {/* Area Charts */}
      <div className="shadow border border-[#D9D9D9] rounded-[10px] h-[330px]">
        <div className="p-5 space-y-2">
          <div className="flex justify-between items-center">
            <h3 className="text-[13px] font-inter font-medium text-[#313439]">
              Booking History
            </h3>
            <p className="font-inter text-[10px] text-[--bg-color-500] leading-[100%] font-medium">
              Last 12 Months
            </p>
          </div>
          <AreaGraph
            data={
              AllModuleInfo?.bookingHistory ? AllModuleInfo.bookingHistory : []
            }
          />
        </div>
      </div>
    </div>
  );
}

export default PlanUsage;
